export default [
	{ text: 'Daily dose not stated', value: 'D' },
	{ text: 'Not known/variable/as required', value: 'N' },
	{ text: 'PBS items that are not measured by dosage (creams and ointments)', value: 'X' },
	{ text: 'Dose per day', value: '-' }
];



// WEBPACK FOOTER //
// ./src/data/doses.js